<template>
  <div>
    <a-modal
      title="修改密码"
      :visible="visible"
      @ok="handleSubmit"
      :confirmLoading="confirmLoading"
      @cancel="showModal(false)"
      :maskClosable="false"
      :width="width"
    >
      <div class="public-modal">
        <a-form :form="form">
          <a-form-item label="请输入原密码" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-input
              autocomplete="off"
              v-decorator="[
                'oldNumber',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入原密码!'
                    },
                    {
                      pattern: /^[^\s]*$/,
                      message: '密码不能包含空格！'
                    },
                    {
                      max: 100,
                      message: '最多可输入100个字符'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="请输入新密码" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-input
              autocomplete="off"
              v-decorator="[
                'newNumber',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入新密码!'
                    },
                    {
                      pattern: /^[^\s]*$/,
                      message: '密码不能包含空格！'
                    },
                    {
                      max: 100,
                      message: '最多可输入100个字符'
                    },
                    {
                      validator: validateToNextPassword
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item label="请确认新密码" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-input
              autocomplete="off"
              v-decorator="[
                'confirmNumber',
                {
                  rules: [
                    {
                      required: true,
                      message: '请确认新密码!'
                    },
                    {
                      pattern: /^[^\s]*$/,
                      message: '密码不能包含空格！'
                    },
                    {
                      max: 100,
                      message: '最多可输入100个字符'
                    },
                    {
                      validator: compareToFirstPassword
                    }
                  ]
                }
              ]"
              @blur="handleConfirmBlur"
            />
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PasswordModal',
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'password_form' })
  },
  data () {
    return {
      visible: false,
      confirmLoading: false,
      confirmDirty: false,
      width: 500,
      infoLoading: false, // 编辑窗口，获取详情loading
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    ...mapActions(['Logout', 'handleUpdatePassWord']),
    showModal (flag) {
      this.formClear()
      this.visible = flag
    },
    handleSubmit (e) {
      this.confirmLoading = true

      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const query = {
            oldNumber: value.oldNumber.trim(),
            newNumber: value.newNumber.trim()
          }

          this.handleUpdatePassWord(query).then(res => {
            if (res.status === 0) {
              this.visible = false
              this.countDown()
            } else {
              this.$message.error(res.info.message)
              if (res.info.message === '原密码错误') {
                this.form.setFields({ 'oldNumber': { value: query.oldNumber, errors: [new Error('原密码错误')] } })
              }
            }
          })
        }
      })
      this.confirmLoading = false
    },
    countDown () {
      let secondsToGo = 3
      const modal = this.$success({
        title: '密码修改成功!',
        content: `${secondsToGo}后将跳转到登录页`
      })
      const interval = setInterval(() => {
        secondsToGo -= 1
        modal.update({
          content: `${secondsToGo}后将跳转到登录页`
        })
      }, 1000)
      setTimeout(() => {
        clearInterval(interval)
        modal.destroy()
        this.Logout({}).then(() => {
          window.location.reload()
        })
      }, secondsToGo * 1000)
    },
    handleConfirmBlur (e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword (rule, value, callback) {
      const form = this.form
      if (value && value !== form.getFieldValue('newNumber')) {
        callback(new Error('两次输入的密码不一致!'))
      } else {
        callback()
      }
    },
    validateToNextPassword (rule, value, callback) {
      const form = this.form
      if (value && this.confirmDirty) {
        form.validateFields(['confirmNumber'], { force: true })
      }
      callback()
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
    },
    cancel () {
      this.formClear()
    }
  }
}
</script>
